import { GetLessonById_getLessonById_focusQuestion } from 'approot/lesson/__generated__/GetLessonById';
import { ContentPageRichtextContent } from 'approot/shared/content-page/content-page-richtext-content';
import { ContentPageText } from 'approot/shared/content-page/content-page.style';
import { getTextFromRichtext } from 'approot/shared/logic/get-text-from-richtext';

const DraftJsFocusQuestionView = ({
  focusQuestion,
}: {
  focusQuestion: GetLessonById_getLessonById_focusQuestion | null;
}) => {
  return <ContentPageRichtextContent content={focusQuestion?.value} />;
};

const TipTapFocusQuestionView = ({
  focusQuestion,
  contentId,
}: {
  focusQuestion: GetLessonById_getLessonById_focusQuestion | null;
  contentId: number;
}) => {
  const content = getTextFromRichtext({
    richtext: focusQuestion?.value,
    sourceFile: 'focus-question-view.tsx',
    contentId,
  });
  return (
    <ContentPageText
      as="div"
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};

type Props = {
  question: GetLessonById_getLessonById_focusQuestion | null;
  activitiesQuestion?: GetLessonById_getLessonById_focusQuestion | null;
  contentId: number;
};

const FocusQuestionView = ({
  question,
  activitiesQuestion,
  contentId,
}: Props) => {
  return activitiesQuestion ? (
    <TipTapFocusQuestionView
      focusQuestion={activitiesQuestion}
      contentId={contentId}
    />
  ) : question ? (
    <DraftJsFocusQuestionView focusQuestion={question} />
  ) : null;
};

export default FocusQuestionView;
